angular.module("mw-alert-template", []).run(["$templateCache", function($templateCache) {
	$templateCache.put("mw-alert.html",
		"<div class=\"mw-alert\" ng-class=\"'alert-' + (message.type || 'warning')\" ng-if=\"message != undefined\"><div class=\"mw-alert-text\">{{message.text}}</div><button type=\"button\" class=\"mw-alert-close\" ng-click=\"close()\" aria-hidden=\"false\"><span aria-hidden=\"true\">×</span></button></div>");
}]);
